import React from 'react';
import { useTranslation } from 'react-i18next';
import CellOverflow from '../cell-overflow/CellOverflow';
import BrandIcon from '../../../../shared/components/brand-icon/BrandIcon';
import {
  type OwnedKeywordDomain,
  visibleDomains,
} from '../../../../shared/helpers/keyword/BrandDomainHelper';
import './KeywordDomainsCell.scss';

// Reguła siedzi w shared — czyta ją też popup „Wybierz marki do analizy” na dashboardzie.
export { visibleDomains };
export type { OwnedKeywordDomain };

interface KeywordDomainsCellProps {
  /** Domeny wszystkich nazw marki (główna + warianty). */
  domains: OwnedKeywordDomain[];
  /** Otwiera okno marki na zakładce „Domeny marki”. */
  onOpen: () => void;
}

/**
 * Domeny marki w komórce tabeli — same chipy; dodawanie i usuwanie jest w oknie marki
 * (`BrandDomainsEditor`). Wykluczonych nie pokazujemy: „×” usuwa domenę z marki w tym projekcie.
 * Niepotwierdzone (patrz `visibleDomains`) są wyszarzone.
 */
export const KeywordDomainsCell: React.FC<KeywordDomainsCellProps> = ({ domains, onOpen }) => {
  const { t } = useTranslation();
  const { shown, confirmed } = visibleDomains(domains);

  const chips = shown.map((domain) => (
    <span
      className={`keyword-domains__chip${confirmed ? '' : ' keyword-domains__chip--unconfirmed'}`}
      title={confirmed ? domain.domain : t('brandDomainsUnconfirmed')}
    >
      <BrandIcon name={domain.domain} domain={domain.domain} size="xs" />
      <span className="keyword-domains__domain">{domain.domain}</span>
    </span>
  ));

  return (
    <CellOverflow
      chips={chips}
      emptyLabel={t('brandDomainsEmpty')}
      openTitle={t('brandDomainAdd')}
      onOpen={onOpen}
    />
  );
};

export default KeywordDomainsCell;
